<template lang="pug">
include ../Bemto
+b.verification-wrapp: +e.wrap
  +b.P.text.--weight-bold.--color-black.--font-serif.--size-2lg.--size-xl-sm {{ _("Майже готово!") }}
  +b.P.text.--size-sm.--color-dark-gray.ma--t-lg {{ _('На вашу пошту') }}
  +b.P.text.--weight-bold.--color-dark-gray.pa--t-xs.pa--b-xs {{ userData.email }}
  +e.P.confirm-text.text.--align-center.--size-sm.--color-dark-gray {{ _('ми надіслали лист, просто натисніть на посилання в ньому, щоб завершити створення акаунта.') }}
  +b.IMG.pa--t-xl.pa--b-2xs(src='/static/img/letter.png')
  +b.P.text.--size-sm.--color-dark-gray {{ _('Немає листа?') }}
  +b.P.text.--size-sm.--color-light-blue.--pointer-black.ma--t-sm.ma--b-sm(
    @click="$emit('send-again')"
  ) {{ _('Надіслати знову') }}

</template>

<script>
import { verificationAPI } from "@requests/services/services"

export default {
  props: {
    userData: Object,
  },
  name: "confirm-email",
  methods: {
    sendAgain(data) {
      verificationAPI.execute({}, data).then(() => {
        this.$notify({
          text: this._("Email sended"),
          type: "success",
        })
      })
    },
  },
}
</script>
